import { render, staticRenderFns } from "./DeleteUser.vue?vue&type=template&id=5fd48846"
import script from "./DeleteUser.vue?vue&type=script&lang=js"
export * from "./DeleteUser.vue?vue&type=script&lang=js"
import style0 from "./DeleteUser.vue?vue&type=style&index=0&id=5fd48846&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports